import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import RtlStyles from './styles/RtlStyles';
import './i18n';
import { useTranslation } from 'react-i18next';

// Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import StructuredData from './components/SEO/StructuredData';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import Home from './components/Home/Home';
import About from './components/About/About';
import Services from './components/Services/Services';
import Experience from './components/Experience/Experience';
import Team from './components/Team/Team';
import Reviews from './components/Reviews/Reviews';

// Pages
import HomePage from './pages/Home/HomePage';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Initialize language from localStorage or browser preference
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
    }
  }, [i18n]);

  return (
    <div className="App" style={{ width: '100%', maxWidth: '100vw', overflow: 'hidden' }}>
      <StructuredData />
      <BrowserRouter>
        <GlobalStyles />
        <RtlStyles />
        <WhatsAppButton />
        <Routes>
          {/* Regular pages with header/footer */}
          <Route path="*" element={
            <>
              <Header />
              <Routes>
                <Route path="/" element={<Home id="home" />} />
                <Route path="/about" element={
                  <div className="page-container">
                    <About id="about" />
                    <Experience id="experience" />
                  </div>
                } />
                <Route path="/services" element={<Services id="services" />} />
                <Route path="/team" element={<Team id="team" />} />
                <Route path="/reviews" element={<Reviews id="reviews" />} />
                <Route path="/home" element={<Navigate to="/" replace />} />
                <Route path="/all" element={<HomePage />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
